<template>
    <span v-if="!url" :class="classes"><slot></slot></span>
    <a v-else-if="is_external" :href="url" :target="link_target" :title="link_title" :class="classes"><slot></slot></a>
    <router-link v-else :to="url" :target="link_target" :title="link_title" :key="url" :class="classes"><slot></slot></router-link>
</template>

<script>

export default {
    name: 'link-item',

    props: {
        link: {
            type: Object,
            default: {},
        },

        post_link: {
            type: String,
            default: '',
        },

        new_window: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            is_newsletter: false,
            is_footer: false,
            is_external: false,
            url: '',
            link_target: '',
            link_title: '',
            classes: [],
        }
    },

    methods: {
        isFile (url) {
            url = new URL(url, location.origin);
            return url.pathname.split('/').pop().indexOf('.') > 0;
        },

        isEmail(url) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(url).toLowerCase());
        },
    },

    mounted() {
        this.url = '';
        this.link_target = '';

        if (Object.keys(this.link).length !== 0) {
            this.classes.push(this.link.classes)
            this.url = this.link.url;
            this.link_target = this.link.target;
            this.link_title = this.link.title;

        } 

        else if (this.isEmail(this.post_link)) {
            this.url = 'mailto:' + this.post_link;
        }
        
        else {
            this.url = this.post_link.replace(window.globals.home_url, '');
        }

        if (this.url.indexOf(window.globals.home_url) !== -1) {
            this.url = this.url.replace(window.globals.home_url, '');
        }

        if ((this.new_window || this.isExternal(this.url) || this.isFile(this.url) || this.link_target === '_black') && !this.isEmail(this.url)) {
            this.link_target = '_black';
            this.is_external = true;
        }

        // console.log(this.new_window , this.isExternal(this.url) , this.isFile(this.url) , this.link_target === '_black')

    },
}

</script>